<template>
    <v-container fluid>
        <!-- Track title -->
        <v-col :alvqa="alvqa + '-title'">
            <v-row class="pl-4 headline">
                {{ item.title }}
                {{ item.version !== null ? ' (' + item.version + ')' : '' }}
            </v-row>
        </v-col>

        <v-row class="pl-4 pr-4 pt-3">
            <v-col cols="1">                 
                <v-img
                    aspect-ratio="1"
                    class="defaultImageEditPage"
                    width="150px"
                    :alvqa="alvqa + '-image'"
                >
                    <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                    ></v-row>
                </v-img>
            </v-col> 
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ARTIST -->
                        <span v-if="item.displayArtist !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-display-artist'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_DISPLAY_ARTIST') }}:</div>
                            <!-- >{{ $t('lang_LABEL_TRACKS_CAPTION_DISPLAY_ARTIST') }}:</div> -->
                            <div :alvqa="alvqa + '-display-artist'">
                                {{ item.displayArtist }}
                            </div>
                        </span>
                <span v-if="getAzName">
                    <div
                        class="read-only-caption"
                        :alvqa="alvqa + '-caption-artist'"
                    >{{ $t('lang_LABEL_TRACKS_CAPTION_ARTIST') }}:</div>
                    <div :alvqa="alvqa + '-artist'">
                        {{ getAzName }}
                    </div>
                    <template v-if="item.artist.alvId">
                        <router-link :to="$alvPlugin.createUrlForAlvId(item.artist.alvId)">{{ item.artist.alvId }}</router-link>
                    </template>
                </span>
                        <!-- ISRC -->
                        <span v-if="item.isrc !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-isrc'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_ISRC') }}:</div>
                            <div :alvqa="alvqa + '-isrc'">
                                {{ item.isrc }}
                            </div>
                        </span>
                        <!-- TAGS -->
                        <span v-if="item.tags !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-tags'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_TAGS') }}:</div>
                            <div :alvqa="alvqa + '-tags'">
                                {{ item.tags }}
                            </div>
                        </span>
                        <!-- Label -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-label-company'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_LABEL') }}:</div>
                            <div :alvqa="alvqa + '-label-company'">
                                {{ getSelectedLabelOfTrack.text }} <router-link  :to="$alvPlugin.createUrlForAlvId(getSelectedLabelOfTrack.alvId)">{{ getSelectedLabelOfTrack.alvId }}</router-link>
                            </div>
                        </span>
                        <!-- ALVID -->
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div :alvqa="alvqa + '-alvid'">
                                {{ item.alvId }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>  
            <v-col v-if="showSecondCard">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- LANGUAGE -->
                        <span v-if="item.language !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-language'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_LANGUAGE') }}</div>
                            <div :alvqa="alvqa + '-language'">
                                {{ $t(getLanguage) }}
                            </div>
                        </span>
                        <!-- DURATION -->
                        <span v-if="item.duration !== null && item.duration !== ''">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-duration'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_DURATION') }}:</div>
                            <div :alvqa="alvqa + '-duration'">
                                <!-- {{ $alvPlugin.transformSecondsToDuration(item.duration) }} -->
                                {{ item.duration }}
                            </div>
                        </span>
                        <!-- OWNERSHIP FROM DATE -->
                        <span v-if="item.rightsOwnershipFrom !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-rights-ownership-from-date'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_RIGHTS_OWNERSHIP_FROM') }}:</div>
                            <div :alvqa="alvqa + '-rights-ownership-from-date'">
                                {{ $d(new Date(item.rightsOwnershipFrom), 'alvDateFormat') }}
                            </div>
                        </span>
                        <!-- INITIAL DATE -->
                        <span v-if="item.initialDate !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-initial-date'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_DATE_INITIAL') }}:</div>
                            <div :alvqa="alvqa + '-initial-date'">
                                {{ $d(new Date(item.initialDate), 'alvDateFormat') }}
                            </div>
                        </span>
                        <!-- EXPLICIT / LIVE / INSTRUMENTAL -->
                        <span                     
                            v-if="  (item.explicit !== null) || 
                                    (item.live !== null) ||
                                    (item.instrumental !== null)"
                        >
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-type'"
                            >
                                {{ $t('lang_LABEL_TRACKS_CAPTION_EXPLICIT') }} / 
                                {{ $t('lang_LABEL_TRACKS_CAPTION_LIVE') }} / 
                                {{ $t('lang_LABEL_TRACKS_CAPTION_INSTRUMENTAL') }}:
                            </div>
                            <div :alvqa="alvqa + '-type'">
                                {{ getYesOrNoTranslated(item.explicit) }} / {{ getYesOrNoTranslated(item.live) }} / {{ getYesOrNoTranslated(item.instrumental) }}
                            </div>
                        </span>
                        <!-- COPYRIGHT -->
                        <span v-if="item.copyright !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-copyright'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_P_NOTICE') }}:</div>
                            <div :alvqa="alvqa + '-copyright'">
                                {{ item.copyright }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>       

            <v-col v-if="showThirdCard">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- LINKED WORK -->
                        <span v-if="item.work !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-linked-work'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_LINKED_WORK') }}:</div>
                            <div :alvqa="alvqa + '-linked-work'">
                                {{ item.work.title }}
                            </div>
                           <template v-if="item.work.gemaNumber !== null || item.work.type !== null">
                                <div class="subtitleGray--text">
                                  {{ showGemaNumberAndType(item.work)}}
                                </div>
                           </template>
                           <router-link :to="`/publishing/works/${item.work.alvId}`">{{ item.work.alvId }}</router-link>
                        </span>
                        <!-- CONTRACTS -->
                        <span v-if="item.contracts !== null && item.contracts.length !== 0">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-contracts'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_CONTRACTS') }}:</div>
                            <div
                                v-for="(contract, i) in item.contracts"
                                :key="i"
                                :alvqa="alvqa + '-contracts-' + contract.alvId"
                            >
                                {{ contract.name }} 
                                <router-link :to="`/contracts/label/${contract.alvId}`">{{ contract.alvId }}</router-link>
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>  

            <v-col v-if="showAlternativeTitlesReleasesNotes">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ALTERNATIVE TITLES -->
                        <span v-if="item.trackName2 !== null || item.trackName3 !== null || item.trackName4 !== null || item.trackName2 !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alternative-titles'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_ALTERNATIVE_TITLES') }}:</div>
                            <div :alvqa="alvqa + '-alternative-titles'">
                                {{ item.trackName2 }}<br />
                                {{ item.trackName3 }}<br />
                                {{ item.trackName4 }}
                            </div>
                        </span>
                        <!-- LINKED RELEASES -->
                        <span v-if="item.releases !== null && item.releases.length !== 0">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-linked-releases'"
                            >{{ $t('lang_LABEL_TRACKS_CAPTION_LINKED_RELEASES') }}:</div>
                            <div
                                v-for="(release, i) in item.releases"
                                :key="i"
                                :alvqa="alvqa + '-linked-release-' + release.alvId"
                            >
                                {{ release.name }} 
                                {{ release.ean !== null ? '(' + release.ean + ')' : 
                                    release.catalogueNumber !== null ? '(' + release.catalogueNumber + ')' :
                                    ''
                                }}
                                <router-link :to="`/label/releases/${release.alvId}`">{{ release.alvId }}</router-link>
                            </div>
                        </span>
                        <!-- NOTES -->
                        <span v-if="item.notes !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERAL_CAPTION_NOTES') }}:</div>
                            <div
                                
                                :alvqa="alvqa + '-notes'"
                            >{{ item.notes }}</div>
                            </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- PANELS -->
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <TracksArtistsReadOnlyPanel :trackAlvId="item.alvId" />
                    <!-- <TracksContractsReadOnlyPanel :trackAlvId="item.alvId" /> -->
                    <TracksMediaReadOnlyPanel :trackAlvId="item.alvId" />
                    <TracksOtherIdsReadOnlyPanel :trackAlvId="item.alvId" />
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { DropdownGenericYesNo } from '@/assets/dropdowns/alvDropdowns.js'

import TracksArtistsReadOnlyPanel from './_panels/1_artists/TracksArtistsReadOnlyPanel'
import TracksContractsReadOnlyPanel from './_panels/2_contracts/TracksContractsReadOnlyPanel'
import TracksMediaReadOnlyPanel from "./_panels/3_media/TracksMediaReadOnlyPanel.vue"
import TracksOtherIdsReadOnlyPanel from './_panels/4_otherids/TracksOtherIdsReadOnlyPanel'

export default {
    name: "TrackReadOnly",
    components: {
        TracksArtistsReadOnlyPanel,
        TracksContractsReadOnlyPanel,
        TracksMediaReadOnlyPanel,
        TracksOtherIdsReadOnlyPanel
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'label-tracks-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedTracks.find(element => {
                return element.id === this.itemId
            })
            return item
        },
        getAzName() {
              return this.$store.getters.getTrackDetailsConnectedArtist;
            },
        getSelectedLabelOfTrack(){ 
            let allLabels = this.$store.getters.getLabelsDropdown 
            let selectedTrackLabelId = this.$store.getters.getTrackDetailsSelectedLabelId 

            let selectedLabelObject = allLabels.find(label => {
                    return label.value === selectedTrackLabelId
            })
            return selectedLabelObject
        },
        showSecondCard() {
            let showDuration = this.item.duration !== null && this.item.duration !== '00:00' && this.item.duration !== ''
            let showInitialDate = this.item.initialDate !== null 
            let showCopyright = this.item.copyright !== null && this.item.copyright !== ''
            
            // type aka explicit, live or instrumental
            let showType = (this.item.explicit !== null && this.item.explicit !== '') || 
                          (this.item.live !== null && this.item.live !== '') ||
                          (this.item.instrumental !== null && this.item.instrumental)

            if(showDuration || showInitialDate || showType || showCopyright) return true
            else return false
        },
        showThirdCard() {
            let showLinkedWork = this.item.work !== null
            let showLinkedContracts = this.item.contracts !== null && this.item.contracts.length !== 0

            return showLinkedWork || showLinkedContracts
        },

        showAlternativeTitlesReleasesNotes() {
            let showAlternativeTitles = 
                this.item.trackName2 !== null || 
                this.item.trackName3 !== null || 
                this.item.trackName4 !== null || 
                this.item.trackName2 !== null

            let showNotes = this.item.notes !== null
            let showReleases = this.item.releases.length !== 0

            if(showAlternativeTitles || showNotes || showReleases) return true
            else return false
        },
        getLanguage() {
            let languages = this.$alvPlugin.getListOfGenericMusicLanguages('label-tracks')
            let selectedLanguage = this.item.language.toLowerCase()

            let match = languages.find(language => {
                return language.value === selectedLanguage
            })

            return match.text
        },
    },

    methods: {
        getYesOrNoTranslated(value) {
            let match = DropdownGenericYesNo.find(element => {
                return element.value === value
            }).text

            return this.$t(match)
        },
        
        showGemaNumberAndType(work) {
            if(work.gemaNumber === null && work.type === null) return work.alvId

            let tempArray = []

            if(work.gemaNumber === null){ 
                return work.statusType
            }else if(work.statusType === null){
                return work.gemaNumber
            }else{
                tempArray = [work.gemaNumber, work.statusType]
                return tempArray.join(', ')
            } 
        },

        getSocietyName(societyCode) {
            return this.$alvPlugin.getSocietyName(societyCode)
        }
    },
    created() {
        this.$store.commit('setSocieties')
    },
}
</script>